import { observer } from "mobx-react-lite"
import { Loader2 } from "lucide-react"
import { activePlayer } from "@/entities/audio-engine"
import { useAutoTranslation } from "@/entities"
import { LANG_KEYS } from "@/shared/constants"
import { cn } from "@/lib/utils"

/**
 * "Word highlighting is still being generated…" chip. Renders nothing unless
 * the chunk currently playing was delivered audio-first (manifest
 * wordsReady=false) and its timestamps haven't landed yet. Reactive via
 * activePlayer.isHighlightPending, so it can sit in any non-observer parent.
 */
export const HighlightPendingBadge = observer(
  ({ className }: { className?: string }) => {
    const { t } = useAutoTranslation()
    if (!activePlayer.isHighlightPending) return null
    return (
      <span
        className={cn(
          "text-muted-foreground inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs",
          className
        )}
        role="status"
        aria-live="polite"
      >
        <Loader2 className="h-3 w-3 animate-spin" />
        {t(LANG_KEYS.HIGHLIGHT_GENERATING)}
      </span>
    )
  }
)
